import { render, staticRenderFns } from "./finalPrice.vue?vue&type=template&id=231821bd&scoped=true"
import script from "./finalPrice.vue?vue&type=script&lang=js"
export * from "./finalPrice.vue?vue&type=script&lang=js"
import style0 from "./finalPrice.vue?vue&type=style&index=0&id=231821bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231821bd",
  null
  
)

export default component.exports